($ =>{
  var settings = {
    max_width: '480',
  }, default_tables = [], cont = 0;


  /**
   * Check if the layout corresponds to mobile or tablet
   * @returns {boolean}
   */
  function isBreakPoint() {
    return $(window).width() <= settings.max_width;
  }

  /**
   * Change the DOM of the tables. Rows to cards.
   * @returns
   */
  function toCards(){
    var tables = $('.container table.cards-table');
    tables.each(function () {
      var table = $(this);
      var caption = table.find('caption').first();
      var cards = $('<div>', { 'class': 'cards', 'id': 'cards' + cont++ });
      var th = table.find('thead th');
      var tr = table.find('tbody tr');
      tr.each(function () {
        var card = $('<div>', { 'class': 'card' });
        var card_head = $('<div>', { 'class': 'card-head' });
        var card_body = $('<div>', { 'class': 'card-body' });
        card.append(card_head.append($(caption).text()));

        if ($(this)[0].className === 'active' ||
          $(this)[0].className === 'danger' ||
          $(this)[0].className === 'warning') {
          card_body.addClass($(this)[0].className);
        }

        $(this).find('td').each(function (index, value) {
          var row = $('<div>', { 'class': 'row card-row' });
          var title_label = $('<span>', { 'class': 'col-sm-6 card-col col-title' });
          var content_label = $('<span>', { 'class': 'col-sm-6 card-col col-value' });
          $(title_label).text(th[index].textContent);
          if($(this).children().length === 0){
            $(content_label).text(this.textContent);
          } else {
            $(content_label).append($(this).children());
          }
          row.append(title_label);
          row.append(content_label);
          card_body.append(row);
        });

        card.append(card_body);
        cards.append(card);
      });
      table.parent().prepend(cards);
      table.remove();
    });
  }

  /**
   * Revert the change of the DOM to default
   * @returns
   */
  function toTable() {
    var cards = $('div[id^=cards]');
    if (cards.length > 0){
      cards.each(function (index, value) {
        $(this).parent().prepend(default_tables[index]);
        $(this).remove();
      });
      default_tables = [];
    }
  }

  $.fn.tableToCards = function(options){

    settings = $.extend({}, settings, options );
    var tables = $('.container table.cards-table');
    //save the initial table DOM for revert after convert tables to cards.
    tables.each(function () {
      default_tables.push($(this).clone());
    });

    if (isBreakPoint()) {
      toCards();
    }

    $(window).on('resize', function() {
      if (isBreakPoint()) {
        var tables = $('.container table.cards-table');
        if(tables.length > 0){
          tables.each(function () {
            default_tables.push($(this).clone());
          });
        }
        toCards();
      } else {
        toTable();
      }
    });
  };
})(jQuery);


// WEBPACK FOOTER //
// ./source/assets/javascripts/plugins/table-to-cards.js